import script from "./settlement.vue?vue&type=script&setup=true&lang=js"
export * from "./settlement.vue?vue&type=script&setup=true&lang=js"

import "./settlement.vue?vue&type=style&index=0&id=84f94840&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-merchant\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84f94840"]])

export default __exports__